import * as React from "react";
import type { UseFormRegisterReturn } from "react-hook-form";

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  PhoneNumberInput,
} from "@/components/ui";

interface PhoneNumberFormFieldProps {
  label?: string;
  type?: HTMLInputElement["type"];
  className?: string;
  register: UseFormRegisterReturn;
  disabled?: boolean;
  dataTestId?: string;
}

export const PhoneNumberFormField = React.forwardRef<
  HTMLInputElement,
  PhoneNumberFormFieldProps & {
    label?: string;
    className?: string;
    register: UseFormRegisterReturn;
  }
>(({ label, className, register, dataTestId }, ref) => {
  return (
    <FormField
      {...register}
      // @ts-expect-error This line is to remove a console error
      ref={null}
      render={({ field }) => (
        <FormItem className={className}>
          <div className="flex">
            {label && <FormLabel>{label}</FormLabel>}
            <FormMessage
              data-testid="error-message"
              className="grow text-right"
            />
          </div>
          <FormControl>
            <PhoneNumberInput
              data-testid={dataTestId}
              {...{
                value: field.value,
                onChange: field.onChange,
                disabled: field.disabled,
              }}
              onChange={(e) => {
                if (!e) {
                  field.onChange("");
                } else {
                  field.onChange(e);
                }
              }}
              innerRef={(element) => {
                field.ref(element);
                if (typeof ref === "function") {
                  ref(element);
                } else if (ref) {
                  ref.current = element;
                }
              }}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
});
PhoneNumberFormField.displayName = "PhoneNumberFormField";
